import { render } from "./invited-buckingham.vue?vue&type=template&id=2831e355&scoped=true"
import script from "./invited-buckingham.vue?vue&type=script&lang=js"
export * from "./invited-buckingham.vue?vue&type=script&lang=js"

import "./invited-buckingham.vue?vue&type=style&index=0&id=2831e355&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2831e355"]])

export default __exports__